import React from 'react'
import TextInput from '@ublique/components/TextInput'

function Text({ onChange, className, fieldValue }) {
  const handleOnChange = (e) => {
    const formattedValue = e.target.value.replaceAll("'", `''`)

    onChange({
      params: { label: e.target.value, value: `'${formattedValue}'` },
      isTriggered: true
    })
  }

  return (
    <TextInput
      key={fieldValue}
      value={fieldValue.label}
      className={`${className}-text`}
      labelText='Value'
      onChange={handleOnChange}
    />
  )
}

export default Text
